import { useCallback, useContext, useEffect } from 'react';
import { useDeleteChatInstanceMutation } from '@trinity/chat-components/components/Chat.History/hooks/index';
import { ActiveChatSessionContext } from './context';
import { ChatApiConfigContext, GroupFeaturesContext } from '@trinity/chat-components/containers/Chat';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';

type Props = {
  children: React.ReactNode;
};

export const ChatSessionEndGuard = (props: Props) => {

  const features = useContext(GroupFeaturesContext);
  const deleteChatsOnSessionEnd = features.deleteChatsOnSessionEnd;

  if (deleteChatsOnSessionEnd) {
    return <Guard {...props} />;
  }

  return (
    <>
      {props.children}
    </>
  );
};

const Guard = (props: Props) => {

  useDeleteChatOnSessionEnd();
  useDeleteChatSessionOnUnload();

  return (
    <>
      {props.children}
    </>
  );
};

function useDeleteChatSessionOnUnload() {
  const chatSession = useContext(ActiveChatSessionContext);
  const chatInstanceId = chatSession.id;

  const apiConfig = useContext(ChatApiConfigContext);

  const deleteChat = useCallback(async () => {
    console.log('ChatSessionEndGuard: deleting chat instance');
    const deleteUrl = `${apiConfig.baseUrl}/chat/${chatInstanceId}/expire`;
    navigator.sendBeacon(deleteUrl);
  }, [chatInstanceId]);

  useEffect(() => {
    if (!chatInstanceId) {
      return;
    }
    window.addEventListener('beforeunload', deleteChat);

    return () => {
      window.removeEventListener('beforeunload', deleteChat);
    };
  }, [chatInstanceId, deleteChat]);
}

function useDeleteChatOnSessionEnd() {
  const chatSession = useContext(ActiveChatSessionContext);

  const chatInstanceId = chatSession.id;

  const { mutateAsync } = useDeleteChatInstanceMutation();

  useEffect(() => {

    return () => {
      if (!chatInstanceId) {
        return;
      }
      console.log('ChatSessionEndGuard: Deleting Chat ', chatInstanceId);
      mutateAsync(chatInstanceId);
    };
  }, [chatInstanceId, mutateAsync]);
}